/**
 * 统一批量上传弹窗控制器
 */
import Vue from 'vue';
import batchUpload from './confirmation-batch-upload-dialog';
import store from '@/store/index.js';
const DialogConstructor = Vue.extend(batchUpload);
const instance = new DialogConstructor({el: document.createElement('div'), store});

const newLoading = {
  show(op) {
    instance.dialogVisible = true;
    instance.queryParams = op.queryParams;
    instance.handlerFunc = op.handlerFunc;
    instance.clickVisible();
    document.body.appendChild(instance.$el);
    document.body.style.overflow = 'hidden';
    console.log('newLoading', op);
    return instance;
  },

  isShow() {
    return instance.dialogVisible;
  },

  hide() {
    instance.dialogVisible = false;
    document.body.style.overflow = '';
  },

  abortUpload(succ_cb) {
    instance.abortUpload(() => {
      this.hide();
      succ_cb && succ_cb();
    });
  }


};

const install = () => {
  if (!Vue.$comConfirmationUploadDialog) {
    Vue.$comConfirmationUploadDialog = newLoading;
  }
  Vue.mixin({
    created() {
      this.$comConfirmationUploadDialog = Vue.$comConfirmationUploadDialog;
    }
  });
};

export default install;
